import { render } from "./FaxNotSentCases.vue?vue&type=template&id=888de0c2"
import script from "./FaxNotSentCases.vue?vue&type=script&lang=js"
export * from "./FaxNotSentCases.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/FaxNotSentCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "888de0c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('888de0c2', __exports__)) {
    console.log('reload')
    api.reload('888de0c2', __exports__)
  }
  
  module.hot.accept("./FaxNotSentCases.vue?vue&type=template&id=888de0c2", () => {
    console.log('re-render')
    api.rerender('888de0c2', render)
  })

}


export default __exports__